import styled from "styled-components";

export const DeliveryFormParent = styled.section`
  width: 70%;
  height: 100%;
`;

export const DeliveryInfoWrapper = styled.div`
  width: 100%;
  height: 100%;
  margin-top: 3rem;
  padding-left:10rem;
`;

export const Heading = styled.h3`
  font-weight: 500;
  font-size: 2rem;
  line-height: 3.4rem;
  color: #1e1e1e;
`;

export const DeliveryForm = styled.form`
  width: 100%;
  height: 60%;
  margin-top: 1rem;
  color:#483C31;
`;

export const DivideWrapper = styled.div`
  display: flex;
  width: 75%;
  gap: 1rem;
  margin-top: 1rem;
`;

export const Side = styled.div`
  width: 50%;
`;

